<template>
  <div>
    <footer class="bg-blue-900 text-white py-3 px-3 md:px-10 shadow-md leading-none flex flex-col items-center md:flex-row md:justify-between md:items-center">
      <h1 class="text-center text-xs text-white tracking-wider">Učíme se online</h1>

      <router-link to="/zdroje" class="my-2 md:my-0 text-center text-xs tracking-wider hover:underline">Zdroje a poděkování!</router-link>

      <h3 class="text-center text-xs text-white tracking-wider">&copy; 2020</h3>
    </footer>
  </div>
</template>
<script>
export default {};
</script>
